import React, {useEffect, useState} from 'react';
import {ScrollView, StyleSheet, ActivityIndicator, View} from 'react-native';
import {RFValue} from 'react-native-responsive-fontsize';
import {apiMasterClin} from '../../../../services/api';
import {SearchInput} from '../../../../components/Interface/Forms/Inputs/SearchInput';
import {Keyboard, TouchableWithoutFeedback} from 'react-native';
import {LinkButton} from '../../../../components/Interface/Forms/Buttons/LinkButton';
import {NotFound} from '../../../../components/Interface/Search/NotFound';
import {FilterItem, FilterItemText, FilterItemIcon, FilterItemRow, FilterItemInfo} from './filter-components.styles';

interface Props {
  cidade: number;
  bairro?: number;
  onSelectBairro: (value: any) => void;
}

export default function FilterBairroContent({cidade, bairro, onSelectBairro}: Props) {
  const [search, setSearch] = useState('');
  const [neighborhoods, setNeighborhoods] = useState<any[]>([]);
  const [filteredNeighborhoods, setFilteredNeighborhoods] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    async function fetchNeighborhoods() {
      await apiMasterClin
        .get(`/endereco/bairros/${cidade}`)
        .then((response: any) => {
          const {data} = response.data;
          if (data && isMounted) {
            setNeighborhoods(data);
            setLoading(false);
          }
        })
        .catch(() => {
          if (isMounted) setLoading(false);
        });
    }

    if (cidade) {
      fetchNeighborhoods();
    }

    return () => {
      isMounted = false;
    };
  }, [cidade]);

  const handleSearchNeighborhoods = (name: string) => {
    const filter = neighborhoods.filter(n =>
      n.nome
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .includes(
          name
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, ''),
        ),
    );
    setFilteredNeighborhoods(filter);
    setSearch(name);
  };

  const displayNeighborhoods = search.length > 0 ? filteredNeighborhoods : neighborhoods;

  return (
    <TouchableWithoutFeedback onPress={Keyboard.dismiss}>
      <View style={styles.container}>
        <SearchInput
          placeholder="Buscar bairro"
          value={search}
          autoCapitalize="sentences"
          onChangeText={handleSearchNeighborhoods}
        />
        <LinkButton
          text="Limpar filtro"
          enabled
          action={() => onSelectBairro(undefined)}
        />

        {loading ? (
          <ActivityIndicator size="large" style={styles.loader} />
        ) : displayNeighborhoods.length > 0 ? (
          <ScrollView
            scrollEnabled
            showsVerticalScrollIndicator={false}
            contentContainerStyle={styles.content}>
            {displayNeighborhoods.map((n, index) => (
              <FilterItem
                key={n.id}
                style={{
                  borderBottomWidth:
                    index === displayNeighborhoods.length - 1 && displayNeighborhoods.length > 1 ? 0 : 1,
                }}
                onPress={() => onSelectBairro(n.id)}>
                <FilterItemRow>
                  <FilterItemInfo>
                    <FilterItemText active={n.id === bairro}>{n.nome}</FilterItemText>
                  </FilterItemInfo>
                  <FilterItemIcon name={n.id === bairro ? 'check' : 'chevron-right'} />
                </FilterItemRow>
              </FilterItem>
            ))}
          </ScrollView>
        ) : (
          <View style={styles.notFound}>
            <NotFound />
          </View>
        )}
      </View>
    </TouchableWithoutFeedback>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: RFValue(24),
    paddingVertical: RFValue(16),
    maxHeight: '80%',
  },
  content: {
    paddingVertical: RFValue(16),
  },
  loader: {
    marginTop: RFValue(20),
  },
  notFound: {
    marginTop: RFValue(20),
  },
});
